export const visit = (vm, at) => {
at({ "sv": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "Nytt meddelande" } } });
};